import NextLink from "next/link";
import type { TemplateLinkProps } from "./types";

export function DefaultTemplateLink({
    href,
    children,
    ...linkProps
}: TemplateLinkProps) {
    return (
        <NextLink href={href} {...linkProps}>
            {children}
        </NextLink>
    );
}
